import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useStore = create(
  persist(
    (set) => ({
      process: 'product',
      setProcess: (newProcess) => set({ process: newProcess }),
    }),
    {
      name: 'process-storage', 
    }
  )
);

export default useStore;
